export default {
    wizardType: "SPANNER",

    getJDBCURL: m => m.get("connectionUrl"),

    getConnectionParams: (type, model) => ({
        ConnectionURL: model.get("connectionUrl")
    })
};
